import React from 'react';
import type { ConnectedProps } from 'react-redux';
import { connect } from 'react-redux';

import { trackBPGEvent } from 'actions';
import { WithFlysiteUrls } from 'components/HOC/WithFlysiteUrls/WithFlysiteUrls';
import type { FlysiteUrls } from 'hooks/useFlysiteUrls';
import { ReactComponent as LinkIcon } from 'icons/link-icon.svg';
import { useTranslations } from 'utils';

import { ReactComponent as LaurelIcon } from './laurel-icon.svg';

import './BestPriceGuaranteed.scss';

type BestPriceGuaranteedProps = ConnectedProps<typeof connector> & FlysiteUrls;

const BestPriceGuaranteedComponent = ({
  bestPriceGuaranteeUrl,
  trackBPGEvent,
}: BestPriceGuaranteedProps) => {
  const i18n = useTranslations();

  return (
    <a
      href={bestPriceGuaranteeUrl}
      onClick={trackBPGEvent}
      data-testid="BestPriceGuaranteed"
      className="BestPriceGuaranteed"
      rel="noopener noreferrer"
      target="_blank"
    >
      <div className="BestPriceGuaranteed-badge">
        <LaurelIcon
          className="BestPriceGuaranteed-icon min-h-16 min-w-16 text-gray-50 md:text-white"
          aria-hidden
        />
      </div>
      <div className="BestPriceGuaranteed-content">
        <h2 className="BestPriceGuaranteed-title">
          {i18n.t('bestPriceGuaranteed.title')}
        </h2>
        <p className="BestPriceGuaranteed-description">
          {i18n.t('bestPriceGuaranteed.description')}
        </p>
      </div>
      <LinkIcon
        className="BestPriceGuaranteed-linkIcon"
        alt="External Link Icon"
      />
    </a>
  );
};

const mapDispatchToProps = {
  trackBPGEvent,
};

const connector = connect(null, mapDispatchToProps);
const BestPriceGuaranteed = connector(
  WithFlysiteUrls(BestPriceGuaranteedComponent),
);

export { BestPriceGuaranteed };
